import { Component } from '@angular/core';
import { EmailTemplateModalComponent } from '../email-template-modal/email-template-modal';

@Component({
  selector: 'app-help-desk',
  imports: [EmailTemplateModalComponent],
  templateUrl: './help-desk.html',
  styleUrl: './help-desk.scss',
})
export class HelpDeskComponent {
  isModalOpen: boolean = false;

  openModal() {
    this.isModalOpen = true;
  }

  closeModal() {
    this.isModalOpen = false;
  }
}